// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3h7GG","notes":"Notes_notes___UWBZ"};